import { useEffect, useState } from 'react';

// Follows tailwind's convention for breakpoints
// https://tailwindcss.com/docs/breakpoints
const BreakPoints = {
  xs: '(max-width: 639px)',
  sm: '(min-width: 640px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  xl: '(min-width: 1280px)',
  '2xl': '(min-width: 1536px)',
};

type BreakPointsType = (typeof BreakPoints)[keyof typeof BreakPoints];

const useMediaQuery = (breakpoint: BreakPointsType): boolean => {
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(BreakPoints[breakpoint]);
    const handleChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    // Set initial state
    setMatches(mediaQueryList.matches);

    // Add listener for changes
    mediaQueryList.addEventListener('change', handleChange);

    // Cleanup listener on unmount
    return () => {
      mediaQueryList.removeEventListener('change', handleChange);
    };
  }, [breakpoint]);

  return matches;
};

export default useMediaQuery;
